import script from "./SupportQuestions.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportQuestions.vue?vue&type=script&setup=true&lang=ts"

import "./SupportQuestions.vue?vue&type=style&index=0&id=074efa77&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074efa77"]])

export default __exports__